import React from 'react';
import FadeAnimation from '../FadeAnimation/FadeAnimation';
import meitBoxesImg from '../../public/images/meitBoxesImg.png';
import Navbar from '../navigation/Navbar';
import SignInForm from './SignInForm';
import DropdownMenu from '../navigation/DropdownMenu';

function UnLoggedLayout() {
  const [isOpen, setIsOpen] = React.useState(false);
  const tooggleOpen = () => {
    setIsOpen(!isOpen);
  };
  return (
    <main className="relative min-h-screen w-full flex">
      <div className="block w-full border-0 absolute top-0 z-20">
        <Navbar openClose={tooggleOpen} />
        {isOpen && <DropdownMenu closeOpen={tooggleOpen} />}
      </div>
      {/* form */}
      <section className="relative z-20 w-full lg:w-5/12 mx-auto flex flex-col items-center justify-center my-5">
        {/* card */}
        <div className="mx-10 my-24 max-w-xl bg-system-100 flex flex-col rounded-lg p-5 sm:p-10 space-y-6 ">
          <FadeAnimation>
            <SignInForm />
          </FadeAnimation>
        </div>
        <div className="w-full text-center">
          <span className="text-color-primary-text-300 ">
            © Momentos Magix, LLC | Políticas de privacidad
          </span>
        </div>
      </section>
      {/* bg boxes */}
      <div className="absolute w-full h-[70vh] bottom-0 overflow-hidden flex">
        <img
          className="relative w-full h-full object-cover object-top mt-auto"
          src={meitBoxesImg.src}
          alt="meit-bg"
        />
      </div>
    </main>
  );
}

export default UnLoggedLayout;
